import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputEmail, ValidationService } from '@sm360/widget-commons-forms';

import LoadingButton from 'login/components/Library/LoadingButton/LoadingButton.jsx';

import AuthenticationService from 'login/services/AuthenticationService/AuthenticationService.js';
import { AnalyticsService } from '@sm360/widget-commons-general';

import TAGS from 'login/constants/trackingTags';

class ForgetPasswordForm extends React.Component {
    constructor(props) {
        super(props);

        this.emailIsRequired = true;

        this.state = {
            btnEnabled: true,
            email: '',
            errorMessage: '',
            isEmailValid: true,
            successMessage: '',
        };

        this.inputCallback = this.inputCallback.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.isFormValid = this.isFormValid.bind(this);
        this.validateInput = this.validateInput.bind(this);
        this.sendRequest = this.sendRequest.bind(this);
    }

    onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    getAnswerMessageValue(error) {
        let errorMessageKey = 'LOGIN.ERROR_MESSAGE.SEND_RESET_CODE_UNKNOWN_ERROR';

        if (error.status === 404) {
            errorMessageKey = 'LOGIN.ERROR_MESSAGE.NO_ACCOUNT_WITH_EMAIL';
        }

        return LocaleService.t(errorMessageKey);
    }

    sendRequest() {
        // axios does not support finally shim -> https://github.com/mzabriskie/axios/issues/34
        AuthenticationService.sendPasswordResetCode(this.state.email)
            .then(() => {
                this.setState({
                    btnEnabled: true,
                    email: '',
                    isEmailValid: true,
                    errorMessage: '',
                    successMessage: LocaleService.t('LOGIN.SUCCESS_MESSAGE.SEND_RESET_CODE_SUCCESS'),
                });

                AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__FORGOT_PASSWORD_SUBMIT());
            })
            .catch((error) => {
                this.setState({
                    btnEnabled: true,
                    email: '',
                    isEmailValid: true,
                    successMessage: '',
                    errorMessage: this.getAnswerMessageValue(error.response),
                });

                AnalyticsService.gaTrigger(TAGS.LOGIN_WIDGET__FORGOT_PASSWORD_SUBMIT());
            });
    }

    submitForm() {
        if (!this.isFormValid()) {
            return;
        }

        this.setState({ btnEnabled: false });

        this.sendRequest();
    }

    inputCallback(value) {
        this.setState({
            email: value,
            isEmailValid: this.validateInput(value),
        });
    }

    isFormValid() {
        return this.state.isEmailValid;
    }

    validateInput(value) {
        return ValidationService.validateIsNotEmpty(value) && ValidationService.validateEmail(value);
    }

    render() {
        return (
            <form
                className="forgotPasswordForm"
                name="forgotPasswordForm"
                method="post"
                acceptCharset="UTF-8"
                onSubmit={this.onSubmit}
            >
                <InputEmail
                    isRequired={this.emailIsRequired}
                    isValid={this.state.isEmailValid}
                    label={LocaleService.t('LOGIN.EMAIL')}
                    valueChange={this.inputCallback}
                    value={this.state.email}
                    classNames={['styled-placeholder']}
                />
                <div className="error-message">{this.state.errorMessage}</div>
                <div className="success-message">{this.state.successMessage}</div>
                <LoadingButton
                    text={LocaleService.t('LOGIN.SEND')}
                    btnCallback={this.submitForm}
                    btnEnabled={this.state.btnEnabled}
                />
            </form>
        );
    }
}

ForgetPasswordForm.displayName = 'ForgetPasswordForm';

export default ForgetPasswordForm;



// WEBPACK FOOTER //
// ./src/components/ForgetPassword/ForgetPasswordForm/ForgetPasswordForm.jsx